<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col>
        <setup-kpi-categories-dialog-create @created="created" />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(category, i) in categories"
        :key="category.name"
        cols="12"
        md="4"
        xl="3"
      >
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="[`elevation-${hover ? 6 : 2}`, 'pa-2']" 
          >
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-capitalize">
                    {{ category.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-uppercase">
                    {{ category.kpi_category_type.name }} KPI
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text--primary text-uppercase">
                    {{ category.metric.name }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action @click="setSelectedIndex(i)">
                  <v-menu
                    bottom
                    left
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"                        
                      >
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>
                  
                    <v-list>
                      <v-list-item @click="$refs.editDialog.toggleDialog(category)">
                        <v-list-item-title> Edit </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="$refs.deleteDialog.toggleDialog(category)">
                        <v-list-item-title> Delete </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>        
        </v-hover>
      </v-col>
    </v-row>    
    <setup-kpi-categories-dialog-edit 
      ref="editDialog"
      @updated="updated"
    />
    <setup-kpi-categories-dialog-delete 
      ref="deleteDialog"
      @deleted="deleted"
    />
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupKpiCategoriesDialogCreate: () => import('@/components/setup/kpi-categories/DialogCreate'),
      SetupKpiCategoriesDialogEdit: () => import('@/components/setup/kpi-categories/DialogEdit'),
      SetupKpiCategoriesDialogDelete: () => import('@/components/setup/kpi-categories/DialogDelete'),
    },
    metaInfo () {
      return {
        title: 'Setup - Kpi Categories',
      }
    },
    data: () => ({
      categories: null,
      selectedIndex: 0,
    }),
    created () {
      this.$api.kpiCategories().list()
        .then(response => {
          this.categories = response.data
        })
    },
    methods: {
      setSelectedIndex (index) {
        this.selectedIndex = index
      },
      created (category) {     
        this.categories.unshift(category)
      },
      updated (category) {
        this.$set(this.categories, this.selectedIndex, category)
      },
      deleted () {
        this.categories.splice(this.selectedIndex, 1)
      },
    },
  }
</script>
